export const inventorySkuConvertor = (sku, replaceStr) => {
    const pattern = new RegExp(`-${replaceStr}`, 'gi');
    return sku.replace(pattern, '')
}